import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState = {
  isOpenModalSaveKnowledge: false,
  isOpenModalCreateFolder: false,
  typeSaveFolder: '',
}

export const notebookSlice = createSlice({
  name: 'notebook',
  initialState,
  reducers: {
    updateIsOpenModalSaveKnowledge: (state, action) => {
      state.isOpenModalSaveKnowledge = action.payload
    },
    updateIsOpenModalCreateFolder: (state, action) => {
      state.isOpenModalCreateFolder = action.payload
    },
    updateTypeSaveFolder: (state, action) => {
      state.typeSaveFolder = action.payload
    },
  },
  extraReducers: builder => {},
})

export const {
  updateIsOpenModalSaveKnowledge,
  updateIsOpenModalCreateFolder,
  updateTypeSaveFolder,
} = notebookSlice.actions
export default notebookSlice.reducer
